import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  Bar,
} from "recharts";

export default function PhaseActiveEnergyBars({ deviceId, API_BASE }) {
  const { t } = useTranslation();
  const [data, setData] = useState([]);

  useEffect(() => {
    async function load() {
      try {
        // 🔥 Import values
        const impRes = await fetch(
          `${API_BASE}/measurements/energy/import-active?deviceId=${deviceId}`
        );
        const imp = await impRes.json();

        // 🔥 Export values
        const expRes = await fetch(
          `${API_BASE}/measurements/energy/export-active?deviceId=${deviceId}`
        );
        const exp = await expRes.json();

        const rows = [
          {
            phase: "L1",
            importVal: Math.trunc(((Number(imp.P1_IMPORT) || 0) / 1000) * 1000) / 1000,
            exportVal: Math.trunc(((Number(exp.P1_EXPORT) || 0) / 1000) * 1000) / 1000,

          },
          {
            phase: "L2",
            importVal: Math.trunc(((Number(imp.P2_IMPORT) || 0) / 1000) * 1000) / 1000,
            exportVal: Math.trunc(((Number(exp.P2_EXPORT) || 0) / 1000) * 1000) / 1000,

          },
          {
            phase: "L3",
            importVal: Math.trunc(((Number(imp.P3_IMPORT) || 0) / 1000) * 1000) / 1000,
            exportVal: Math.trunc(((Number(exp.P3_EXPORT) || 0) / 1000) * 1000) / 1000,

          },
        ];

        setData(rows);
      } catch (err) {
        console.error("PhaseActiveEnergyBars error:", err);
      }
    }

    load();
  }, [deviceId, API_BASE]);

  return (
    <div className="bg-white border rounded-xl p-5 shadow-sm">
      <h3 className="text-base font-semibold mb-4 text-slate-700">
        {t('energies.phaseActiveTitle')}
      </h3>

      <div className="h-80">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="phase" />
            <YAxis />
            <Tooltip formatter={(val) => `${val.toFixed(3)} kWh`} />
            <Legend />

            <Bar dataKey="importVal" name={t('energies.importkWh')} fill="#16a34a" />
            <Bar dataKey="exportVal" name={t('energies.exportkWh')} fill="#eab308" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
